import React from 'react'
import Flower from './flower/Flower'

export default function Footer() {
  return (
    <>
    <Flower/>
    </>
  )
}
